const GITHUB_API_BASE = 'https://api.github.com'

export const fetchUserRepos = async (username, { perPage = 100, sort = 'updated' } = {}) => {
  try {
    const url = `${GITHUB_API_BASE}/users/${username}/repos?per_page=${perPage}&sort=${sort}&type=owner`
    const response = await fetch(url)
    if (!response.ok) throw new Error('Failed to fetch repos')
    const repos = await response.json()

    // Fetch topics for each repo (topics require the mercy preview header)
    const reposWithTopics = await Promise.all(
      repos.map(async (repo) => {
        try {
          const topicsRes = await fetch(`${GITHUB_API_BASE}/repos/${username}/${repo.name}/topics`, {
            headers: { Accept: 'application/vnd.github.mercy-preview+json' }
          })
          if (topicsRes.ok) {
            const { names } = await topicsRes.json()
            return { ...repo, topics: names || [] }
          }
        } catch { /* ignore */ }
        return { ...repo, topics: repo.topics || [] }
      })
    )

    return reposWithTopics
  } catch (error) {
    console.error('Error fetching repos:', error)
    throw error
  }
} 